import * as React from "react";

import DetailDrawer from "@/components/DetailDrawer";
import DirectoryPanel from "./DirectoryPanel";

/**
 * On-shift directory drawer — modal wrapper around DirectoryPanel for
 * < xl viewports. The ≥ xl persistent rail lives in `DirectoryRail`.
 */
export default function DirectoryDrawer({ open, onOpenChange, companyId, canPost, onOpenConversation }) {
  const handleOpen = (id) => {
    if (onOpenConversation) onOpenConversation(id);
    onOpenChange(false);
  };
  return (
    <DetailDrawer
      open={open}
      onOpenChange={onOpenChange}
      title="On shift now"
      subtitle="Live directory across your sites"
      testid="comms-directory-drawer"
    >
      {open && (
        <DirectoryPanel
          companyId={companyId}
          canPost={canPost}
          onOpenConversation={handleOpen}
          testidPrefix="directory"
        />
      )}
    </DetailDrawer>
  );
}
